import React from 'react';
import { Grid, Paper, } from '@material-ui/core';

const Rating = props => (
  <Grid item xs={12}>
  <Paper className="rating" style={{backgroundColor: props.color, marginLeft: "1rem", marginTop: ".5rem", marginBottom: "1rem"}}>
    <Grid container spacing={2} item xs={12}>
    <Grid item xs={6}>
      {props.rating}
    </Grid>
    <Grid item xs={6}>
      {props.interpretation}
    </Grid>
    </Grid>
  </Paper>
  </Grid>
);

export default Rating;


// WEBPACK FOOTER //
// ./src/pages/Rating.js